export default __webpack_public_path__ + "static/media/bokun-logo-simple-white.cb796f33.svg";